/**
 * Video file extension to MIME type mapping.
 * Used for video playback and upload validation.
 */
export const VIDEO_EXTENSION_MIME_MAP: Readonly<Record<string, string>> = Object.freeze({
  '.mp4': 'video/mp4',
  '.mov': 'video/quicktime',
  '.insv': 'video/mp4', // Insta360 video format (MP4-compatible container)
});

/**
 * File extensions that are 360-degree videos and require special playback.
 */
export const VIDEO_360_EXTENSIONS: readonly string[] = Object.freeze(['.insv']);

/**
 * Check if a filename has a 360-degree video extension.
 */
export function is360VideoFile(fileName: string): boolean {
  const lowerName = fileName.toLowerCase();
  return VIDEO_360_EXTENSIONS.some((ext) => lowerName.endsWith(ext));
}

/**
 * Get MIME type for a video file based on its extension.
 * Returns the mapped MIME type or 'video/mp4' as default.
 */
export function getVideoMimeType(fileName: string): string {
  const lowerName = fileName.toLowerCase();
  for (const [ext, mimeType] of Object.entries(VIDEO_EXTENSION_MIME_MAP)) {
    if (lowerName.endsWith(ext)) {
      return mimeType;
    }
  }
  return '';
}

/**
 * Get MIME type from a URL (strips query parameters).
 */
export function getVideoMimeTypeFromUrl(url: string): string {
  const urlWithoutQuery = url.split('?')[0];
  return getVideoMimeType(urlWithoutQuery);
}
